import type {ComponentStageData} from '../../../../types'
import {getTargetLayoutPointer} from '../../../../conversionDal/utils/pointer'
import {isStackContainerLayout} from '../../../common'

export const createOrderRealStructure = ({componentPointer, conversionDal, initialSnapshot}: ComponentStageData) => {
    const component = conversionDal.get(componentPointer)

    if (!component?.components?.length || component.type !== 'Container' || component.isSlottedComponent) {
        return
    }

    if (!isStackContainerLayout({initialSnapshot, componentPointer})) {
        return
    }

    conversionDal.modify(componentPointer, value => ({
        ...value,
        components: [...value.components].sort((childIdA, childIdB) => {
            const orderA = initialSnapshot.getValue(getTargetLayoutPointer({id: childIdA}))?.itemLayout?.order
            const orderB = initialSnapshot.getValue(getTargetLayoutPointer({id: childIdB}))?.itemLayout?.order

            if (orderA !== undefined && orderB !== undefined) {
                return orderA - orderB
            }
            if (orderA !== undefined) return -1
            if (orderB !== undefined) return 1
            return 0
        })
    }))
}

export {positionItems} from './flush'
